"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlTargetingParams = void 0;
const EMPTY_VALUE = '';
// UTM parameters
const URL_TERM = 'utm_term';
const URL_SOURCE = 'utm_source';
const URL_CAMPAIGN = 'utm_campaign';
const URL_MEDIUM = 'utm_medium';
const URL_CONTENT = 'utm_content';
const URL_TRAFFIC_SOURCE = 'traffic_source';
// Others
const URL_TYPE = 'type';
const URL_FEATURE = 'feature';
/**
 * Extract the UTM params from the URL
 * Pass empty string for non existing parameters
 * @param parsedURL
 */
function getUrlTargetingParams(parsedURL) {
    const { searchParams } = parsedURL;
    return {
        utm_term: searchParams.get(URL_TERM) || EMPTY_VALUE,
        utm_source: searchParams.get(URL_SOURCE) || EMPTY_VALUE,
        utm_campaign: searchParams.get(URL_CAMPAIGN) || EMPTY_VALUE,
        utm_medium: searchParams.get(URL_MEDIUM) || EMPTY_VALUE,
        utm_content: searchParams.get(URL_CONTENT) || EMPTY_VALUE,
        traffic_source: searchParams.get(URL_TRAFFIC_SOURCE) || EMPTY_VALUE,
        type: searchParams.get(URL_TYPE) || EMPTY_VALUE,
        feature: searchParams.get(URL_FEATURE) || EMPTY_VALUE,
    };
}
exports.getUrlTargetingParams = getUrlTargetingParams;
//# sourceMappingURL=index.js.map